
const NitroButton = ({ onClick, formIsValid, label='NOT SET'} ) => {

  return (
    <div className="container max-w-lg">
      <button
        disabled={(formIsValid) ? 0 : 1}
        onClick={onClick}
        className={"font-black text-xs md:text-base w-full rounded p-3 md:p-4 transition-all duration-700 nitro-btn"}>
        {label}
      </button>
    </div>
  );

}

export default NitroButton;
